<template>
    <div style="pointer-events: none">
        <DxButton :text="value" type="normal" styling-mode="contained" />
    </div>
</template>

<script setup>
import DxButton from 'devextreme-vue/button';
import { defineProps } from 'vue';

defineProps({
    value: {
        default: '',
        required: true,
        type: String,
    },
});
</script>

<style lang="scss" scoped>
:deep(.dx-button) {
    width: 100%;
    .dx-button-text {
        width: 100%;
        text-align: start;
    }
}
</style>
